export const ProcessFieldUniqueName = "process";
export const SupportingRoleFieldUniqueName = "supportingRole";
export const ImprovementLeaderFieldUniqueName = "improvementLeader";
export const ContactPersonFieldUniqueName = "contactPerson";
export const PublishAsGeneratedPdfFieldUniqueName = "publishAsGeneratedPdf";
export const KmaChapterFieldUniqueName = "kmachapter";
export const KmaFolderFieldUniqueName = "kmafolder";
